import { logOutSideEffect } from '@ping/authorization/side-effects';
import { WEBSOCKET_URL_NOTIFICATION } from '@ping/configs';
import { queryClient } from '@ping/providers/ReactQueryProvider';
import { tokenStore } from '@ping/stores/token.store';
import { userInformationStore } from '@ping/stores/userInformation.store';
import { WSConnect } from '@ping/websockets';

interface ISignoutResetOptions {
  withRevoke?: boolean;
}

/**
 * It clears the token and user information from the respective stores
 */
export const signoutReset = (options?: ISignoutResetOptions) => {
  /*
    Read off the argument rather than destructured in the signature. Some call sites reach this
    through a DOM click handler, which passes the click event as the argument; destructuring
    `withRevoke` out of an event yields undefined and skipped revocation, whereas an absent option
    has to mean revoke.
  */
  const withRevoke = options?.withRevoke ?? true;

  const tokenQuery = `${tokenStore.getAccessToken()}`;
  const connection = WSConnect(`${WEBSOCKET_URL_NOTIFICATION}?access_token=${tokenQuery}`);
  connection.stop();
  withRevoke && logOutSideEffect();
  tokenStore.revokeToken();
  userInformationStore.revokeUserInformation();
  queryClient.clear();
  sessionStorage.removeItem('UI_HELPER');
};
